module.exports = __webpack_public_path__ + "h5/img/projectBg.7143633d.png";